// Single source of truth for the order-export display labels (order type, priority, status).
//
// orderLabels.data.json (next to this file) is the CANONICAL copy — edit it here. The Go
// backend reads a byte-identical generated copy (backend/internal/server/exportlabels/labels.json,
// produced by `go generate ./internal/server/exportlabels` / the export-labels lefthook hook), so
// the app's labels and the CSV export's labels can never drift. A test on each side guards equality.
//
// The frontend and backend build as separate Docker images, so they cannot share one physical
// file; this is the standard "one canonical source + generated copy + drift guard" pattern (like
// sqlc). NOTE: this is the export/display label source, not order_workflow_definitions (whose
// labels differ and are a separate, product-owned concern).
import labels from './orderLabels.data.json';

/** moldOrderType -> Thai label — backs getOrderTypeLabel / moldOrderTypes. */
export const orderTypeLabelMap: Record<string, string> = labels.orderType;

/** priority -> Thai label, keyed by the numeric priority or 'default' — backs getPriorityLabel. */
export const priorityLabelMap: Record<string, string> = labels.priority;

// company -> order group -> bucket ("all" or a workflow-version number) -> status -> Thai label.
// Backs companyConfig statusMapping (read by getStatusText). JSON object keys are strings, so the
// type keys are strings throughout; consumers index it with the version string / "all".
export const statusLabelsByCompany = labels.status as Record<string, Record<string, Record<string, Record<string, string>>>>;
